import React from 'react';
import { View, Flex } from '@smarterservices/smarter-ui';

/**
 * SectionToolbar Component
 * 
 * A reusable toolbar component for section headers in SessionDetails.
 * Provides a consistent styled container with space-between layout for actions.
 * 
 * @component
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Content to render inside the toolbar (typically Flex.Items)
 * 
 * @returns {JSX.Element} Rendered toolbar container
 * 
 * @example
 * <SectionToolbar>
 *   <Flex.Item>
 *     <Button>Action 1</Button>
 *   </Flex.Item>
 *   <Flex.Item>
 *     <Button>Action 2</Button>
 *   </Flex.Item>
 * </SectionToolbar>
 * 
 * @description
 * Features:
 * - Secondary background with primary border
 * - Medium border radius for rounded corners
 * - Consistent padding and margins
 * - Flex layout with space-between alignment
 * - Vertically centers content
 */
const SectionToolbar = ({ children }) => {
    return (
        <View
            as="div"
            background="secondary"
            borderColor="primary"
            borderRadius="medium"
            borderWidth="small"
            padding="x-small"
            margin="none none xx-small none"
        >
            <Flex justifyItems="space-between" alignItems="center">
                {children}
            </Flex>
        </View>
    );
};

export default SectionToolbar;